/**
 * A customer's mail, as a file: `.eml` or `.msg`.
 *
 * By suffix, like the drawing guard in `DropArea` — a courtesy that decides
 * where a drop goes, not the authority. The server reads the file and refuses
 * what is not a mail (`POST /cases/from-mail`).
 */
const MAIL_SUFFIXES = [".eml", ".msg"];

export function isMail(file: File): boolean {
  const name = file.name.toLowerCase();
  return MAIL_SUFFIXES.some((suffix) => name.endsWith(suffix));
}
